<template>
  <div class="p-billing__not-enabled">
    <VMessage type="info" subtype="basic">
      <template v-slot:icon>
        <InfoCircleIcon />
      </template>
      <template v-slot:text>
          {{ $t('companySettings.billing.billingNotEnabled') }}
        </template>
    </VMessage><br />
    <VButton
        type="cta-3"
        target="_blank"
        href="https://app.signable.co.uk/billing/view"
        data-ec="billing_page"
        data-et="manage_old_billing_button">
      <WrenchIcon />
      <span>{{ $t('companySettings.billing.manageBilling')}}</span>
    </VButton>
  </div>
</template>

<script>
import VMessage from '@/components/deprecated/atoms/Message.vue';
import VButton from '@/components/deprecated/atoms/Button.vue';
import { InfoCircleIcon, WrenchIcon } from '@/components/icons/fontIcons';

export default {
  name: 'BillingOldBillingWarning',
  components: {
    VMessage,
    VButton,
    WrenchIcon,
    InfoCircleIcon,
  },
  props: {
    newBillingEnabled: Boolean,
  },
};
</script>
